<script>
    import { onMount } from "svelte";

    export let label = "Uhrzeit";
    export let name;
    export let value;           // "1000" (derived from internal value)
    let internal_value;         // "10:00"
    let input;
    let valid;

    const placeholder = "--:--"
    const maxlength="5"
    const autocomplete="off"
    const inputmode="text"
    const pattern = "[0-2][0-9]:[0-5][0-9]";
    
    onMount(() => {
        internal_value = value ? value.slice(0, 2)+":"+value.slice(2, 4) : undefined;
    })

    function formatDate () {
        let allowedInputs = /^[0-9]$/;
        if (internal_value.length == 2 || internal_value.length == 3) {
            allowedInputs = /^[0-9]|\:$/;
        }
        if (!allowedInputs.test(internal_value[internal_value.length-1]) && internal_value.length > 0) {
            internal_value = internal_value.slice(0, -1);
        }
        switch(internal_value.length) {
            case 1:
                if (parseInt(internal_value[0]) > 2) {
                    internal_value = "0" + internal_value[0] + ":";
                }
                break;
            case 2:
                // 1: => 01:
                if (internal_value[1] == ":") {
                    internal_value = "0" + internal_value[0] + ":";
                }
                // 24 => 02:4
                // 26 => 02:06
                else if (parseInt(internal_value[0]+internal_value[1]) > 23) {
                    if (parseInt(internal_value[1]) > 5) {
                        internal_value = "0" + internal_value[0] + ":0" + internal_value[1];
                    } else {
                        internal_value = "0" + internal_value[0] + ":" + internal_value[1];
                    }
                }
                break;
            case 3:
                if (internal_value[2] != ":") {
                    if (internal_value[2] > 5) {
                        internal_value = internal_value[0] + internal_value[1] + ":0" + internal_value[2];
                    } else {
                        internal_value = internal_value[0] + internal_value[1] + ":" + internal_value[2];
                    }
                }
                break;
        }
    }

    function finalizeDate () {
        if (!internal_value) {
            value = undefined;
            valid = false;
            return
        }
        
        if (internal_value.length > 5) {
            // alert('"' + internal_value + '" ist keine gültige Uhrzeitenangabe. Die Uhrzeit muss das Format "HH:MM" haben.')
            value = undefined;
            internal_value = undefined;
            valid = false;
            return
        }

        switch(internal_value.length) {
            case 1:
                internal_value = "0" + internal_value[0] + ":00";
                break
            case 2:
                internal_value = internal_value[0] + internal_value[1] + ":00";
                break
            case 3:
                internal_value = internal_value + "00";
                break
            case 4:
                internal_value = internal_value + "0";
                break
        }
        if (!internal_value.match(pattern)) {
            // alert('"' + internal_value + '" ist keine gültige Uhrzeitenangabe. Die Uhrzeit muss das Format "HH:MM" haben.')
            value = undefined;
            internal_value = undefined;
            valid = false
            return
        }
        value = internal_value.replace(":", "");
        valid = true;
        return
    }

    function selectAll() {
        input.setSelectionRange(0, internal_value?internal_value.length:0);
    }
</script>


<label>
    <span class="label">
        {label}
    </span>
    <input
        type="text"
        bind:value={internal_value}
        bind:this={input}
        on:click={selectAll}
        on:input={formatDate}
        on:blur={finalizeDate}
        class:invalid={valid === false}
        {name}
        {placeholder}
        {maxlength}
        {autocomplete}
        {inputmode}
        {pattern}
    >
</label>

<style>
    label {
        margin-bottom: 1rem;
    }

    .label {
        display: block;
        margin-bottom: 0.2rem;
        font-size: 0.8rem;
    }

    input {
        display: block;
        border-radius: 0.5rem;
        border: 2px solid #F5F2EF;
    }

    .invalid:not(:focus-within) {
        animation: shake 0.4s linear;
    }

    @keyframes shake {
        0% {
            transform: translateX(-10px);
            border-color: #DA4A2B;
        }
        25% {
            transform: translateX(9px);
        }
        50% {
            transform: translateX(-4px);
        }
        75% {
            transform: translateX(2px);
        }
        100% {
            transform: translateX(0px);
        }
    }
</style>

